import apinode from '../../apinode'

class SubCategoriesService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll() {
    const response = await apinode.get(`/subcategories/${this.idconta}`)

    return response.data
  }

  async getBySearch(search) {
    const response = await apinode.get(
      `/subcategories/${this.idconta}?search=${search}`,
    )

    return response.data
  }

  async getById(id) {
    const response = await apinode.get(`/subcategories/${id}/${this.idconta}`)

    return response.data
  }

  async create({ name, categoryId }) {
    await apinode.post(`/subcategories/${this.idconta}`, {
      name,
      categoryId,
    })
  }

  async update(id, { name, categoryId }) {
    await apinode.put(`/subcategories/${id}/${this.idconta}`, {
      name,
      categoryId,
    })
  }

  async delete(id) {
    await apinode.delete(`/subcategories//${id}/${this.idconta}`)
  }
}

export default new SubCategoriesService()
